import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  browseRates: {
    defaultMessage: 'Browse Rates',
    id: 'J88p9b',
    description: 'rateBrowserConfigurationForm.submit',
  },
  browseFreightRates: {
    defaultMessage: 'Browse freight rates',
    id: 'LT1/X1',
    description: 'rateBrowserConfigurationForm.browseFreightRatesLink',
  },
  browseFreightRatesDisabledTooltip: {
    defaultMessage: 'Requires the Freight: Book Shipments permission',
    id: 'TaWL91',
    description: 'rateBrowserConfigurationForm.browseFreightRatesDisabledTooltip',
  },
  configureRates: {
    defaultMessage: 'Configure Rates',
    id: 'yB98SR',
    description: 'rateBrowserConfigurationForm.header',
  },
  serviceClassificationShowAll: {
    defaultMessage: 'Show All',
    id: '/i1XOt',
    description: 'rateBrowser.serviceClassification.showAll',
  },
});

export const labelMessages = defineMessages({
  city: {
    defaultMessage: 'City',
    id: '0athfv',
    description: 'rateBrowserConfigurationForm.shipToCity',
  },
  confirmation: {
    defaultMessage: 'Confirmation',
    id: 'FSrYWi',
    description: 'rateBrowserConfigurationForm.confirmationType',
  },
  country: {
    defaultMessage: 'Country',
    id: 'qJNruZ',
    description: 'rateBrowserConfigurationForm.shipToCountry',
  },
  package: {
    defaultMessage: 'Package',
    id: 'yNnF1i',
    description: 'rateBrowserConfigurationForm.packageType',
  },
  postalCode: {
    defaultMessage: 'Postal Code',
    id: '8pzSVO',
    description: 'rateBrowserConfigurationForm.shipToPostalCode',
  },
  residentialAddress: {
    defaultMessage: 'Residential Address',
    id: 'HD8Zvm',
    description: 'rateBrowserConfigurationForm.shipToResidentialAddress',
  },
  serviceClass: {
    defaultMessage: 'Service Class',
    id: '1sOyCN',
    description: 'rateBrowserConfigurationForm.serviceClassification',
  },
  shipFrom: {
    defaultMessage: 'Ship From',
    id: 'mDWoFe',
    description: 'rateBrowserConfigurationForm.shipFromHeader',
  },
  shipTo: {
    defaultMessage: 'Ship To',
    id: '+8pmVJ',
    description: 'rateBrowserConfigurationForm.shipToHeader',
  },
  shipmentInformation: {
    defaultMessage: 'Shipment Information',
    id: 'mV4p43',
    description: 'rateBrowserConfigurationForm.shipmentInformationHeader',
  },
  size: {
    defaultMessage: 'Size',
    id: '5+t3uX',
    description: 'rateBrowserConfigurationForm.packageDimensions',
  },
  dimensionsProvided: {
    defaultMessage: 'Dimensions provided by carrier.',
    id: 'QB28R4',
    description: 'Tooltip shown on the dimensions input when the selected carrier package type has fixed dimensions',
  },
  suburb: {
    defaultMessage: 'Suburb',
    id: 'CvbbBD',
    description: 'rateBrowserConfigurationForm.shipToSuburb',
  },
  shipFromHeader: {
    defaultMessage: 'Ship From',
    id: 'mDWoFe',
    description: 'rateBrowserConfigurationForm.shipFromHeader',
  },
  shipToHeader: {
    defaultMessage: 'Ship To',
    id: '+8pmVJ',
    description: 'rateBrowserConfigurationForm.shipToHeader',
  },
  shipToCountry: {
    defaultMessage: 'Country',
    id: 'qJNruZ',
    description: 'rateBrowserConfigurationForm.shipToCountry',
  },
  shipToPostalCode: {
    defaultMessage: 'Postal Code',
    id: '8pzSVO',
    description: 'rateBrowserConfigurationForm.shipToPostalCode',
  },
  shipToCity: {
    defaultMessage: 'City',
    id: '0athfv',
    description: 'rateBrowserConfigurationForm.shipToCity',
  },
  shipToSuburb: {
    defaultMessage: 'Suburb',
    id: 'CvbbBD',
    description: 'rateBrowserConfigurationForm.shipToSuburb',
  },
  shipToResidentialAddress: {
    defaultMessage: 'Residential Address',
    id: 'HD8Zvm',
    description: 'rateBrowserConfigurationForm.shipToResidentialAddress',
  },
  shipmentInformationHeader: {
    defaultMessage: 'Shipment Information',
    id: 'mV4p43',
    description: 'rateBrowserConfigurationForm.shipmentInformationHeader',
  },
  weight: {
    defaultMessage: 'Weight',
    id: 'o97VzA',
    description: 'rateBrowserConfigurationForm.weight',
  },
  pickup: {
    defaultMessage: 'Pickup',
    id: '18WtBx',
    description: 'rateBrowserConfigurationForm.pickup',
  },
  packageType: {
    defaultMessage: 'Package',
    id: 'yNnF1i',
    description: 'rateBrowserConfigurationForm.packageType',
  },
  packageDimensions: {
    defaultMessage: 'Size',
    id: '5+t3uX',
    description: 'rateBrowserConfigurationForm.packageDimensions',
  },
  confirmationType: {
    defaultMessage: 'Confirmation',
    id: 'FSrYWi',
    description: 'rateBrowserConfigurationForm.confirmationType',
  },
  serviceClassification: {
    defaultMessage: 'Service Class',
    id: '1sOyCN',
    description: 'rateBrowserConfigurationForm.serviceClassification',
  },
  driverTip: {
    defaultMessage: 'Driver Tip',
    id: '2HaCjU',
    description: 'rateBrowserConfigurationForm.driverTip',
  },
  instructions: {
    defaultMessage: 'All fields required to browse rates',
    id: 'JG2/rk',
    description: 'rateBrowserConfigurationForm.instructions',
  },
  header: {
    defaultMessage: 'Configure Rates',
    id: 'yB98SR',
    description: 'rateBrowserConfigurationForm.header',
  },
  submit: {
    defaultMessage: 'Browse Rates',
    id: 'J88p9b',
    description: 'rateBrowserConfigurationForm.submit',
  },
});
